import { CtControlTypes, CtSelectControlValue } from "@ctsolution/ct-framework";
import { CustomCompanySetupEnum } from "../../components/company/company-edit/company-edit.component";

/**
 * Configurazione di un singolo campo LeadInformation da aggiungere dinamicamente
 * al form del lead.
 *
 * - `type`           : codice numerico dell'enum ContactInformationTypeVO (es. 101)
 * - `controlType`    : tipo di controllo Angular Material (default: CtControlTypes.TEXT)
 * - `flexPercentage` : larghezza percentuale nella griglia del form (default: 50)
 */
export interface LeadInformationFieldConfig {
  type: number;
  controlType?: CtControlTypes;
  flexPercentage?: number;
}

export class CTConfigurationModel {

  visible: boolean = true;
  customCompanySetup: CustomCompanySetupEnum = CustomCompanySetupEnum.BASE;
  customContactSetup: CustomCompanySetupEnum = CustomCompanySetupEnum.BASE;
  customCompanyTemplate = 'company-information-model.json';
  customContactTemplate = 'contact-information-model.json';
  label?: string;
  type?: number;
  cols: Array<string> = [];
  visibleWorkOrder: boolean = true;
  doubleClickOpenDetail: boolean = false;
  expanded: boolean = false;
  formatPrice: number = 2;
  formatNumber: number = 2;
  multiCheckBoxTable: boolean = false;
  bypassLeadStatus: boolean = false;
  useDefaultVAT: boolean = false;
  visibleHintRowWorkOrder: boolean = true;
  cloneRowEnabled: boolean = true;
  
  // Abilita la modalità ConfigurationCode per le Quotation (passa ConfigurationCode nel body invece di filtri client-side)
  enableConfigurationCodeMode: boolean = false;
  exportExcelEnabled: boolean = false;

  // Controlla se abilitare la navigazione onCreate nel work-order-list
  allowOnCreate: boolean = true;

  // Controlla se mostrare il bottone Detail nella handling-list
  // E se mostrare la textarea ItemNotes nello step1 del wizard (default true = backward compatible)
  handlingDetailEnabled: boolean = true;

  /**
   * Abilita la sezione LeadInformation nel form del lead.
   * Default `false` per backward-compatibility: la funzionalità si attiva
   * esplicitamente per-client tramite `getComponentOverride`.
   */
  leadInformationEnabled: boolean = false;

  /**
   * Elenco dei campi LeadInformation da aggiungere dinamicamente al form del lead.
   * Ogni entry specifica il codice del tipo, il tipo di controllo e la larghezza.
   * Valori omessi vengono completati con i default (TEXT, 50%).
   * Esempio:
   *   [
   *     { type: 101, controlType: CtControlTypes.TEXT, flexPercentage: 50 },
   *     { type: 102, controlType: CtControlTypes.TEXTAREA, flexPercentage: 100 }
   *   ]
   */
  leadInformationFields: LeadInformationFieldConfig[] = [];

  // Colonne da mostrare nella dialog di dettaglio articoli dell'ordine.
  // Valori ammessi: 'code' | 'name' | 'description' | 'price' | 'qty' | 'additionalCode' | 'price1000'
  handlingDetailVisibleColumns: string[] = ['code', 'name', 'description', 'additionalCode', 'price', 'price1000', 'qty'];

  showTotalRow: boolean = false;
  legendsItem: Array<any> = [
    { color: '#A82A26', label: 'Presentation Call', description: 'Appuntamento di presentazione ufficiale con cliente o prospect' },
    { color: '#2196F3', label: 'Appuntamento', description: 'Appuntamento con potenziale cliente' },
    { color: '#E1C11F', label: 'Mail', description: 'Mail in attesa di essere inviata' },
    { color: '#06820D', label: 'Commessa - Inizio lavori', description: 'Avvio operativo di una commessa o progetto' },
    { color: '#780E82', label: 'Offerta - Da inviare', description: 'Offerta pronta, in attesa di essere inviata' },
    { color: '#FF9800', label: 'Call', description: 'Telefonata per seguire una trattativa già avviata' },
    { color: '#FF148D', label: 'Lead - Attività proattiva', description: 'Iniziativa autonoma verso nuovi lead' },
    { color: '#12CED5', label: 'Offerta - In trattativa', description: 'Offerta inviata, in attesa di risposta o trattativa attiva' },
    { color: '#884916', label: 'Commessa - Verifica stato', description: 'Controllo avanzamento lavori su commessa' },
    { color: '#44D130', label: 'Proattiva', description: 'Promemoria di proattività' },
    { color: '#008080', label: 'Follow up', description: 'Controllo stato avanzamento' },
    { color: '#000000', label: 'Kick Off', description: 'Kick off con cliente o interno' }
  ];

  visibleFields: string[] = [
    'DisplayName',
    'ReferenceName',
    'FiscalCode',
    'VAT',
    'Places'
  ];

  valueOptions: any | null = null;

  constructor() { }

  public static create = (): CTConfigurationModel => new CTConfigurationModel();

  setVisible(value: boolean): CTConfigurationModel {
    this.visible = value;
    return this;
  }

  setLabel(value: string): CTConfigurationModel {

    this.label = value;
    return this;

  }

  setType(value: number): CTConfigurationModel {
    this.type = value;
    return this;
  }

  setCols(value: Array<string>): CTConfigurationModel {
    this.cols = value;
    return this;
  }

  setCustomSetup(value: CustomCompanySetupEnum): CTConfigurationModel {
    this.customCompanySetup = value;
    return this;
  }
  setDoubleClickOpenDetail(value: boolean): CTConfigurationModel {
    this.doubleClickOpenDetail = value;
    return this;
  }

  setExpanded(value: boolean): CTConfigurationModel {

    this.expanded = value;
    return this;

  }

  setLegendsItem(value: Array<any>): CTConfigurationModel {

    this.legendsItem = value;
    return this;

  }

}
